import React from "react";
import injectSheet from "react-jss";
import { purgeState } from "../../../utils/localStorage";
import { TextButton } from "../..";

const Home = (props) => {
  const {
    classes,
    history,
    steps,
    incomplete,
    home: { background, ...home },
  } = props;

  const handleClick = () => {
    if (incomplete > 0) {
      purgeState();
      window.location.reload();
    }
    history.push(steps[0].config.path);
  };

  return (
    <div className={`${classes.container}`}>
      <div
        className={`${classes.backgroundContainer}`}
        style={{
          backgroundImage: `url(${process.env.REACT_APP_BASE_PATH}${background})`,
        }}
      >
        <div className={`${classes.ctaContainer}`}>
          <p className={`${classes.textContainer}`}>{home.intro}</p>
          <div className={`${classes.buttonContainer}`}>
            <TextButton
              index={101}
              handleClick={() => handleClick()}
              primary
              text={home.start}
              className={`${classes.startButton}`}
              classes={{
                text: classes.startButtonText,
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

const styles = (theme) => ({
  container: {
    height: "100vh",
    width: "100vw",
    padding: `${theme.sizes.header}px 0 ${theme.sizes.footerExpanded}px 0`,
    [theme.media.medium]: {
      padding: `${theme.sizes.headerLarge}px 0 ${theme.sizes.footerExpanded}px 0`,
    },
  },
  backgroundContainer: {
    backgroundSize: "cover",
    backgroundPosition: "center center",
    height: "100%",
    position: "relative",
    width: "100%",
  },
  ctaContainer: {
    bottom: "15%",
    padding: "0 5%",
    position: "absolute",
    left: "50%",
    transform: "translateX(-50%)",
    width: "100%",
    [theme.media.medium]: {
      bottom: "20%",
      left: "auto",
      right: "20%",
      transform: "none",
      width: "auto",
    },
  },
  buttonContainer: {
    flexGrow: 1,
    display: "flex",
    justifyContent: "flex-end",
    position: "absolute",
    top: "75%",
    right: "0%",
    [theme.media.medium]: {
      right: "10%",
    },
  },
  textContainer: {
    backgroundColor: "#E5E5E5",
    borderRadius: "0.5rem",
    fontSize: "14px",
    fontWeight: "bold",
    padding: "1rem",
    lineHeight: "1rem",
    [theme.media.medium]: {
      borderRadius: "1.5rem",
      fontSize: "20px",
      lineHeight: "1.5rem",
      maxWidth: "44ch",
      padding: "2rem",
    },
    [theme.media.extraLarge]: {
      borderRadius: "1.5rem",
      fontSize: "28px",
      lineHeight: "1.75rem",
      maxWidth: "44ch",
      padding: "3rem",
    },
  },
  startButton: {
    borderRadius: "0.5rem !important",
    [theme.media.medium]: {
      borderRadius: "1.5rem !important",
    },
  },
  startButtonText: {
    borderRadius: "1rem",
    fontSize: "32px",
    height: "100%",
    width: "100%",
    [theme.media.large]: {
      borderRadius: "2rem",
      fontSize: "56px",
      padding: "1rem",
    },
    [theme.media.extraLarge]: {
      fontSize: "74px",
      padding: "1.25rem",
    },
  },
});

export default injectSheet(styles)(Home);



// WEBPACK FOOTER //
// ./src/modules/core/components/home.jsx